/* Ardor designer presets (Oct 18 2026). Opens a designer on an exact size/style: ?preset=flag:FA-S | stand:XS-24x63 | cover:TT6-3 | model:simpo,order:inserts | style:frame,size:16x16 | size:24x18 | mode:gang,len:24 | w:6,h:3 | tab:Product,btn:3~Full wall (Nth button whose text starts with...). flag/stand/cover/model use the designer API, w/h set banner size, other keys click [data-KEY=VALUE]. Skipped when ?ai= is present. */
(function () {
  var q = new URLSearchParams(location.search);
  var raw = q.get('preset');
  if (!raw || q.get('ai')) return;
  var pairs = raw.split(',').map(function (s) { var i = s.indexOf(':'); return i < 0 ? null : [s.slice(0, i).trim(), s.slice(i + 1).trim()]; }).filter(Boolean);
  if (!pairs.length) return;
  var API = { flag: ['ArdorFlagAPI', 'pickFlag'], stand: ['ArdorStandAPI', 'pickStand'], cover: ['ArdorTableAPI', 'pickCover'], model: ['ArdorAFrameAPI', 'pickModel'] };
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function esc(v) { return (window.CSS && CSS.escape) ? CSS.escape(v) : v.replace(/"/g, '\\"'); }
  function findBtn(k, v) { return document.querySelector('[data-' + k + '="' + esc(v) + '"]:not([disabled])'); }
  function setBannerSize(k, v) {
    var el = document.querySelector(k === 'w' ? '[data-abb-w]' : '[data-abb-h]') || Array.prototype.slice.call(document.querySelectorAll('input[type=number]')).filter(function (i) { return (k === 'w' ? /^width/i : /^height/i).test(i.getAttribute('aria-label') || ''); })[0];
    if (el) { el.value = v; el.dispatchEvent(new Event('input', { bubbles: true })); el.dispatchEvent(new Event('change', { bubbles: true })); return true; }
    var B = window.ArdorBannerBuilder;
    if (B && B.state) { B.state[k] = String(v); if (typeof B.render === 'function') B.render(); return true; }
    return false;
  }
  function visBtns() { return Array.prototype.slice.call(document.querySelectorAll('button')).filter(function (b) { return b.offsetParent && !b.disabled; }); }
  function byText(v) { var m = /^(\d+)~(.*)$/.exec(v); var n = m ? +m[1] : 1, t = (m ? m[2] : v).toLowerCase(); var hits = visBtns().filter(function (b) { return b.textContent.trim().replace(/\s+/g, ' ').toLowerCase().indexOf(t) === 0; }); return hits[n - 1] || null; }
  function ready() {
    var k = pairs[0][0];
    if (API[k]) { var a = window[API[k][0]]; return !!(a && typeof a[API[k][1]] === 'function'); }
    if (k === 'w' || k === 'h') return !!window.ArdorBannerBuilder;
    if (k === 'tab' || k === 'btn') return !!byText(pairs[0][1]);
    return !!findBtn(k, pairs[0][1]);
  }
  async function run() {
    for (var t = 0; t < 80 && !ready(); t++) await wait(150);
    if (!ready()) return;
    await wait(250);
    for (var i = 0; i < pairs.length; i++) {
      var k = pairs[i][0], v = pairs[i][1];
      try {
        if (API[k]) { var a = window[API[k][0]]; if (a && typeof a[API[k][1]] === 'function') a[API[k][1]](v); }
        else if (k === 'w' || k === 'h') setBannerSize(k, v);
        else if (k === 'tab' || k === 'btn') { var tb = null; for (var m2 = 0; m2 < 20 && !(tb = byText(v)); m2++) await wait(100); if (tb) tb.click(); }
        else { var b = null; for (var n = 0; n < 20 && !(b = findBtn(k, v)); n++) await wait(100); if (b) b.click(); }
      } catch (e) { if (window.console) console.warn('ardor preset', k, v, e); }
      await wait(200);
    }
    document.documentElement.setAttribute('data-ardor-preset', raw);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
